export const formatMarginRequirement = (
    marginRequirement: number | undefined,
    numberFormatter: Intl.NumberFormat
): string => {
    if (marginRequirement !== undefined) {
        if (marginRequirement === 999 || marginRequirement === 0) {
            return 'N/A';
        } else {
            return `${numberFormatter.format(marginRequirement)}${marginRequirement > 0 ? '%' : ''}`;
        }
    }
    return 'N/A';
};
